import { color, MiscUtils, TZABrandGuidelines, useLink } from '@my/util'
import { ActionButton, Image, ScrollView, SimpleText, XStack, YStack, ActiveButton } from '@my/ui'
import { shadowGenerator } from '../../../utils/commonStyles'
import assets from '../../../assets/images'

// KeyInsights component: displays a horizontal scrollable list of insights
export const KeyInsights: React.FC<KeyInsightsProps> = ({ insights }) => {
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={{
        paddingEnd: 20,
        gap: 10,
      }}
      padding={'$4'}
      paddingBottom={'$6'}
    >
      {insights?.map((item, index) => <InsightCard key={index} index={index} item={item} />)}
    </ScrollView>
  )
}

// InsightCard component to encapsulate the rendering logic of each insight
const InsightCard: React.FC<{ index: number; item: any }> = ({ index, item }) => (
  <YStack
    width={'$18'}
    paddingVertical={'$4'}
    padding={'$4'}
    borderRadius={10}
    minHeight={250}
    backgroundColor={color.white}
    {...shadowGenerator(0.3)}
    style={{position: 'relative'}}
  >
    {/* Insight header */}
    <XStack alignItems="center" marginBottom={'$3'}>
      <XStack 
        style={{
          justifyContent: 'center', alignItems: 'center', borderRadius: 100, height: 50, width: 50,
          borderWidth: 1,
          borderColor: 'rgba(220,220,220, .15)'
        }} 
        {...MiscUtils.ui.shadowGenerator(0.03,5)}
      >
        <Image src={assets.keyInsight} style={{height: 24, width: 24}} resizeMode="contain" />
      </XStack>
      <SimpleText marginHorizontal={'$2'} color={color.darkNavy} fontWeight={'700'} fontSize={18}>
        Insight {index + 1}
      </SimpleText>
    </XStack>

    {/* Insight description */}
    <SimpleText
      fontWeight={'400'}
      fontSize={16}
      color={'#555555'}
      fontStyle="italic"
      lineHeight={25}
    >
      {item.description.length > 106 ? item.description.slice(0, 100) + '...' : item.description}
    </SimpleText>

    {/* View Details button */}
    <ActiveButton
      style={{
        height: 32, width: 102, 
        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
        marginTop: 'auto'
      }}
      ButtonTextProps={{ children: 'View Details'}}
      elevation={1}
      variant="outlined"
      {...useLink('/key-insights')}
    />
    {/* <ActionButton
      unstyled
      borderWidth={1}
      position="absolute"
      style={{alignItems: 'center', justifyContent: 'center'}}
      hoverStyle={{backgroundColor: 'rgb(240,240,240)'}}
      bottom={10}
      left={'$4'}
      backgroundColor={color.white}
      borderColor={color.tzaGreen}
      height={32}
      width={102}
      color={color.tzaGreen}
      borderRadius={4}
      fontWeight={'600'}
      fontSize={12}
      {...useLink('/key-insights')}
    >
      View Details
    </ActionButton> */}
  </YStack>
)
